/**
 * @author Satyamurthy
 * @description 
 */
import React, { useEffect, useState, Fragment, useRef } from 'react';
import { Tag } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import { config } from '../../constant';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import { arrayOfObjects } from '../../../Mock/MockJson';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';

const Funnel = (props) => {
    const [option, setOption] = useState(getInitialOption(props));
    const [refreshDateTime, setRefreshDateTime] = useState(moment());
    const [errorInAPI, setErrorInAPI] = useState(false);
    const [noDataInDB, setNoDataInDB] = useState(false);
    const abortController = useRef(new window.AbortController());
    let timeTicket = useRef(null);
    const requestCheck = useRef(true);

    const {
        graphprops,
        selectionDate,
        selectionMonth,
        DeviceCode,
        selectionDateRange,
        dayMonthYear,
        currentTimeZone,
    } = props;

    useEffect(() => {
        if (timeTicket.current) {
            clearInterval(timeTicket.current);
        }
        let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
        timeTicket.current = setInterval(() => {
            if (requestCheck.current) {
                getData();
            }
        }, refreshTime);
        return () => {
            abortController.current.abort();
            clearInterval(timeTicket.current);
        };
    }, []);

    useEffect(() => {
        getData(props);
    }, [
        selectionDate,
        selectionMonth,
        selectionDateRange,
        DeviceCode,
        dayMonthYear,
        props.translationCache
    ]);
    const getData = async () => {
        let json = [];
        let errorInAPIFlag = false;
        let noDataInDBFlag = false;

        if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
            json = arrayOfObjects;
            requestCheck.current = true;
        } else {
            if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
                json = graphprops.currentDateData;
            } else {
                if (
                    graphprops &&
                    ((graphprops.DashboardLevelSelection === 'datePicker' ||
                        graphprops.GraphLevelSelection === 'datePicker') &&
                        selectionDate) ||
                    (
                        (graphprops.DashboardLevelSelection === 'monthPicker' ||
                            graphprops.GraphLevelSelection === 'monthPicker') &&
                        selectionMonth) ||
                    (
                        (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
                            graphprops.GraphLevelSelection === 'dateRangePicker') &&
                        selectionDateRange) ||
                    (
                        (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
                            graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
                        dayMonthYear) ||
                    (
                        (graphprops.DashboardLevelSelection === 'deviceSelection' ||
                            graphprops.GraphLevelSelection === 'deviceSelection') &&
                        DeviceCode)
                ) {
                    json = await getChartDataWithSelection({
                        graphprops,
                        selectionDate,
                        selectionMonth,
                        selectionDateRange,
                        DeviceCode,
                        dayMonthYear,
                        abortController: abortController.current,
                        currentTimeZone,
                    });
                    requestCheck.current = true;
                } else if (
                    graphprops.GraphLevelSelection === 'none' ||
                    graphprops.DashboardLevelSelection === 'none'
                ) {
                    json = await getChartDataWithoutSelection({
                        graphprops,
                        abortController: abortController.current,
                        DeviceCode,
                        TimeZone: currentTimeZone,
                    });
                    requestCheck.current = true;
                }
            }
        }

        if ((json && json.message) || (Array.isArray(json) && json.length === 0 && !props.graphprops?.enableMock)) {
            if (json.message) {
                errorInAPIFlag = true;
            } else if (json.length === 0) {
                noDataInDBFlag = true;
            }
        }

        if (Array.isArray(json)) {
            const series = json.map((val) => ({ value: val.Value, name: val.Name }));
            const updatedOption = cloneDeep(option);
            updatedOption.series[0].data = [...series];
            setOption(updatedOption);
        }

        setErrorInAPI(errorInAPIFlag);
        setNoDataInDB(noDataInDBFlag);
        setRefreshDateTime(moment());
    };

    return (
        <Fragment>
            {props.graphprops?.checked === true && (
                <Tag className="graphTag" color="blue">
                    {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
                </Tag>
            )}
            {noDataInDB ? (
                <NoRecordComponent />
            ) : errorInAPI ? (
                <ErrorComponent />
            ) : (
                <ReactEcharts
                    option={option}
                    style={{ height: '90%', width: '100%' }}
                    className="react_for_echarts"
                />
            )}
        </Fragment>
    );
};

const getInitialOption = (props) => ({
    title: {},
    tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c}%'
    },
    legend: {
        data: ['data1', 'data2', 'data3', 'data4', 'data5'],
        textStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black',
            fontSize: 18,
            fontWeight: 'bold'
        }
    },
    calculable: true,
    series: [
        {
            name: 'Funnel',
            type: 'funnel',
            left: '10%',
            top: 60,
            bottom: 60,
            width: '80%',
            min: 0,
            max: 100,
            minSize: '0%',
            maxSize: '100%',
            sort: 'descending',
            gap: 2,
            label: {
                normal: {
                    show: true,
                    position: 'inside'
                },
                emphasis: {
                    textStyle: {
                        fontSize: 20
                    }
                }
            },
            labelLine: {
                normal: {
                    length: 10,
                    lineStyle: {
                        width: 1,
                        type: 'solid'
                    }
                }
            },
            itemStyle: {
                normal: {
                    borderColor: '#fff',
                    borderWidth: 1
                }
            },
            data: []
        }
    ]
});

const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};

export default connect(mapStateToProps)(Funnel);
